module.exports = __webpack_public_path__ + "static/media/separation_of_concerns.5334868d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/presentations/state-of-styling/assets/separation_of_concerns.jpg
// module id = 237
// module chunks = 0